<!--
  - Copyright (c) Interactive Information R & D (I2RD) LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - I2RD LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with I2RD.
  -->

<template>
  <v-container fluid class="pa-0 root-container">
    <loading-overlay :value="loading" />
    <iframe
      sandbox="allow-scripts allow-modals allow-forms allow-same-origin allow-top-navigation-by-user-activation"
      class="responsive-iframe"
      :src="fdrUrl"
      :onload="(loading = false)"
    >
    </iframe>
  </v-container>
</template>

<style scoped lang="scss">
.root-container {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.responsive-iframe {
  border: none;
  width: 100%;
  height: 100%;
  display: block;
}
</style>
<script>
import { getCurrentUser } from "@/services/shared";
import LoadingOverlay from "@/components/LoadingOverlay.vue";

export default {
  name: "FDRWrapper",
  components: { LoadingOverlay },
  methods: {
    getCurrentUser
  },
  data() {
    return {
      loading: true
    };
  },
  computed: {
    vendorId() {
      return getCurrentUser().vendorId;
    },
    fdrUrl() {
      // Use next line for local dev if you don't want to run the app, but see caveat in README
      // const baseUrl = new URL("https://vendorproof.test3.dev-providertrust.com/fdr");
      const baseUrl = new URL("/fdr", window.location.href);
      baseUrl.searchParams.append("vendorId", this.vendorId);
      return baseUrl.href;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      document
        .querySelector("iframe")
        .contentWindow.document.querySelector("button[type=submit]")
    ) {
      if (
        window.confirm("Leave the page? Changes you made may not be saved.")
      ) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
};
</script>
